import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function changeStateGroup(groupId, state) {
  try{
    const data = await axios.put(`${REACT_APP_API}/groups/${groupId}`, {state}) 
    return data?.data
  }catch(error){
      throw new Error(error)
  }
}
